module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJRJREFUOBFjYKAHqKiouEUte5jQDFJF45PNRTeYbIPQNbKgC8D4lZWVW////+8F46PTjIyM29rb273RxWF8nC7GZyhIMyF5nAbDbCaXHkYGgyKHQDBsJSCPkAZmkP8IHmUsmoUx2ekY3T/o6RqniwmlU3SD0dXjNBhdI6n8YWQwEekYPXRwp+shkY7RI+82uv8GHR8AMBwoL5DznA4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignLeft_disabled.png
// module id = 309
// module chunks = 0